import { memo } from "react";

function Icon_RigFracActivityVsTime() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true">
      <path d="M2 2V26H28V28H0V2H2Z" fill="currentColor" />
      <path
        d="M19.1904 20.4961L20 19.5781V24H16V19.166L19.1904 20.4961Z"
        fill="currentColor"
      />
      <path d="M20 12.0195L17.8086 14.5029L16 13.749V3H20V12.0195Z" fill="currentColor" />
      <path d="M26 24H22V17.3115L26 12.7783V24Z" fill="currentColor" />
      <path d="M26 5.21973L22 9.75293V0H26V5.21973Z" fill="currentColor" />
      <path d="M14 18.332V24H10V21.0332L13.083 17.9502L14 18.332Z" fill="currentColor" />
      <path d="M14 12.916L11.916 12.0479L10 13.9639V7H14V12.916Z" fill="currentColor" />
      <path d="M8 24H7.03516L8 23.0342V24Z" fill="currentColor" />
      <path d="M8 15.9639L4 19.9639V11H8V15.9639Z" fill="currentColor" />
      <path
        d="M27.6836 8.60339L18.7764 18.6981L12.7334 16.1796L5.5 23.4139L4.08594 21.9999L12.2666 13.8192L18.2236 16.3016L26.1836 7.28015L27.6836 8.60339Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(Icon_RigFracActivityVsTime);
